import React, { useState } from "react";
import Header from "./Header";
import AboutUs from "./AboutUs";
import WhyChooseUs from "./WhyChooseUs";
import OurServices from "./OurServices";
import Testimonials from "./Testimonials";
import RequestQuote from "./RequestQuote";
import LatestBlog from "./LatestBlog";
import Footer from "./Footer";

function Home() {
  const [isLoading, setIsLoading] = useState(true);

  React.useEffect(() => {
    // Hide spinner after component mounts
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // Hide after 1 second

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div>
      {/* Spinner Start */}
      {isLoading && (
        <div
          id="spinner"
          className="bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      {/* Spinner End */}

      <Header />
      <div
          id="header-carousel"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img className="w-100" src="/img/Hero Image (1920 x 1080).jpg" alt="Digital Marketing Hero" />
              <div
                className="carousel-caption d-flex flex-column align-items-center justify-content-center"
              >
                <div className="p-3" style={{ maxWidth: "900px" }}>
                  <p className="text-white text-uppercase mb-3 animated slideInDown fs-4">
                    Creative & Innovative
                  </p>
                  <h1 className="display-1 text-white mb-md-4 animated zoomIn fs-9">
                    UAE's Best Digital Marketing Agency
                  </h1>
                  <p className="text-white text-uppercase mb-5 animated slideInDown fs-4">
                    Solutions Beyond Expectations
                  </p>
                  <a
                    href="/free-quote"
                    className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"
                  >
                    Free Quote
                  </a>
                  <a
                    href="/contact"
                    className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight"
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      <AboutUs />
      <WhyChooseUs />
      <OurServices />
      <Testimonials />
      <RequestQuote />
      <LatestBlog />
      <Footer />
    </div>
  );
}

export default Home;